//
//
//
//
//
//
//
//
//
//
//
//
//
const CategoryDescription = () => import(
/* webpackChunkName: "category" */
'~/components/molecules/Category/CategoryDescription.vue');

const CategoryLinkMapping = () => import(
/* webpackChunkName: "category" */
'~/components/molecules/Category/CategoryLinkMapping.vue');

export default {
  name: 'CategoryInformationalContent',
  components: {
    CategoryDescription,
    CategoryLinkMapping
  },
  props: {
    info: {
      type: Object,
      required: true
    }
  },
  computed: {
    withQuickAccessLinks() {
      return this.info.quick_access_links && this.info.quick_access_links.length;
    }

  }
};